export default __webpack_public_path__ + "static/media/banner_plus.3f7337e9.svg";